import React from 'react'
import './Checkbox.css'


export default function Checkbox(props) {
  return (
    <label htmlFor={props.id} className="checkbox">
      <input   className="checkbox__input" type="checkbox" id={props.id} onChange={props.onChange} value={props.value} />
      <svg className="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
        <rect className='border' x="0" y="0" fill="#FFF" rx="3" />
        <path className="tick" stroke="#f3bb48" fill="none" strokeLinecap="round" strokeWidth="4" d="M4 10l5 5 9-9" />
      </svg>
      <span className="checkbox__label">{props.label}</span>
    </label>
  )
}





